import React, { useEffect, useState } from 'react';
import { Modal, Table, message, Tooltip, Tag } from 'antd';
import axios from '../../config/axiosInstance';

const UserSessionsModal = ({ visible, onClose, user }) => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && visible) {
      fetchUserSessions(user._id);
    }
  }, [user, visible]);

  const fetchUserSessions = async (userId) => {
    setLoading(true);
    try {
      const response = await axios.get(`/users/session/${userId}`);
      
      if (!Array.isArray(response.data)) {
        console.error('Unexpected response format:', response.data);
        setSessions([]); 
      } else {
        setSessions(response.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        message.warning('No sessions found for this user.');
      } else {
        message.error('Error loading user sessions');
      }
      setSessions([]); 
    }
    setLoading(false);
  };

  const columns = [
    {
        title: 'IP Address',
        dataIndex: 'ipAddress',
        key: 'ipAddress',
        width: 150,
        responsive: ['xs', 'sm', 'md', 'lg'],
        render: (text) => {
          if (!text || text === 'N/A') {
            return <Tag color="volcano">N/A</Tag>;
          }
      
          if (text === '::1' || text === '127.0.0.1') {
            return <Tag color="orange">localhost</Tag>;
          }
      
          return <Tag color="blue">{text}</Tag>;
        },
    },
    {
      title: 'User Agent',
      dataIndex: 'userAgent',
      key: 'userAgent',
      width: 160,
      responsive: ['md', 'lg'], 
      ellipsis: true,
      render: (text) =>
        text && text !== 'Unknown' ? (
          <Tooltip title={text}>
            {text.length > 15 ? (
              <Tag color="geekblue">{text.substring(0, 15)}...</Tag>
            ) : (
              <Tag color="geekblue">{text}</Tag>
            )}
          </Tooltip>
        ) : (
          <Tag color="red">Unknown</Tag>
        ),
    },
    {
      title: 'Platform',
      dataIndex: 'platform',
      key: 'platform',
      width: 120,
      responsive: ['sm', 'md', 'lg'],
      render: (text) =>
        text && text !== 'Unknown' ? (
          <Tag color="geekblue">{text}</Tag>
        ) : (
          <Tag color="red">Unknown</Tag>
        ),
    },
    {
      title: 'Language',
      dataIndex: 'language',
      key: 'language',
      width: 100,
      responsive: ['md', 'lg'],
      render: (text) =>
        text && text !== 'Unknown' ? (
          <Tag color="purple">{text}</Tag>
        ) : (
          <Tag color="red">Unknown</Tag>
        ),
    },
    {
      title: 'Connected At',
      dataIndex: 'connectedAt',
      key: 'connectedAt',
      width: 180,
      responsive: ['sm', 'md', 'lg'],
      render: (text) =>(<Tag color="cyan">{new Date(text).toLocaleString('de-DE')}</Tag>) 
    },
    {
      title: 'Disconnected At',
      dataIndex: 'disconnectedAt',
      key: 'disconnectedAt',
      width: 180,
      responsive: ['md', 'lg'],
      render: (text) =>
        text ? (
          <Tag color="volcano">{new Date(text).toLocaleString('de-DE')}</Tag>
        ) : (
          <Tag color="green">Active</Tag>
        ),
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
      width: 130,
      responsive: ['xs', 'sm', 'md', 'lg'],
      render: (text) =>
        text && text !== 'Active session' ? (
          <Tag color="gold">{text}</Tag>
        ) : (
          <Tag color="green">Active session</Tag>
        ),
    },
  ];  

  return (
    <Modal
      open={visible}
      title={`User Sessions - ${user?.username}`}
      onCancel={onClose}
      footer={null}
      width={1200}
    >
      <Table
        columns={columns}
        dataSource={sessions}
        loading={loading}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
        scroll={{ x: 'max-content' }}
      />
    </Modal>
  );
};

export default UserSessionsModal;